import React from 'react';
import { ROUTES } from '../../../constants';
import { Button } from '../../shared';
import { useNavigate } from "../../../backend/navigation";

export const Error404 = () => {
  const navigate = useNavigate();
  return (
    <div className="error-page mb-5">
      <div className="container ">
        <div className="row ">
          <div className="col-md-12 ">
            <div className="error-template d-flex flex-column align-items-center justify-content-center">
              <h1>Oops!</h1>
              <h2>404 Not Found</h2>
              <div className="error-details">
                Sorry, an error has occured, Requested page not found!
              </div>
              <div className="error-actions d-flex gap-3">
                <Button
                  clickHandler={() => navigate(ROUTES.HOME)}
                  className={
                    'border blue-btn d-flex align-items-center justify-content-center py-2 px-3'
                  }>
                  Take Me Home
                </Button>

                <Button
                  className={
                    'border white-btn d-flex align-items-center justify-content-center py-2 px-3'
                  }>
                  Contact Support
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
